import { render } from "./Gallery.component.vue?vue&type=template&id=77343cea&ts=true"
import script from "./Gallery.component.vue?vue&type=script&lang=ts"
export * from "./Gallery.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__